import gql from "graphql-tag";

const CREATE_OFFER = gql`
  mutation createOffer($orderData: OrderInput!, $onlySave: Boolean) {
    createOffer(orderData: $orderData, onlySave: $onlySave)
  }
`;

export default CREATE_OFFER;
